import React, { useState } from "react";
import { ProSidebarProvider } from "react-pro-sidebar";
import Dashboard from "./Components/Dashboard";
import Login from "./Components/Login";
import useToken from "./Components/useToken";

function App() {
  const { token, setToken } = useToken();

  if (!token) {
    return <Login setToken={setToken} />;
  }
  return (
    <ProSidebarProvider>
      <Dashboard setToken={setToken} />
    </ProSidebarProvider>
  );
}

export default App;
